import { CountupModule } from './countup';
import { RadialProgressSetup } from './radial_progress';
import { _t } from '@bark/bark-core';
import { formatNumber } from 'libphonenumber-js';
import moment from 'moment-timezone';

function _exposeToWindow(bconnect) {
	window.Bark.BarkConnect = bconnect;
}

export function BarkConnect() {
	const load = () => {
		/**
		 * Window.Bark
		 * @type {}
		 */
		var Bark = (window.Bark = window.Bark || {});

		var BarkConnect = {};

		window.CountUpModule = CountupModule() || {};
		window.RadialProgress = RadialProgressSetup() || {};

		var unavailableTimes = {};

		var ommittedTimezones = ['GMT', 'UTC', 'BST'];

		BarkConnect.modalId = '#barkConnectModal';
		BarkConnect.barkConnectCallFlowGroupInstanceHash = undefined;
		BarkConnect.lastInstanceHash = false;
		BarkConnect.calleeUserType = null;
		BarkConnect.calleeUserTypeId = 0;
		BarkConnect.calleeName = null;
		BarkConnect.forType = undefined;
		BarkConnect.forTypeId = undefined;
		BarkConnect.timeOut = undefined;
		BarkConnect.callDelay = 5000;
		BarkConnect.lastStatus = 'no_active_call';
		BarkConnect.debug = !location.host.match(/^(www|bark)/i);
		BarkConnect.scheduledCallProjectId = null;
		BarkConnect.scheduledCallCalleeUserType = null;
		BarkConnect.scheduledCallCalleeUserTypeId = null;
		BarkConnect.scheduledCallDefaultTime = '09:00:00';
		BarkConnect.activityLog = null;
		BarkConnect.callerNumber = null;
		BarkConnect.smsCallback = false;

		BarkConnect.init = function () {
			this.bind();
		};

		BarkConnect.setCallerNumber = function (number) {
			if (number === null) {
				return;
			}
			let formattedNumber = '';
			try {
				formattedNumber = formatNumber(number, 'NATIONAL');
				if (formattedNumber.length === 0) {
					formattedNumber = formatNumber('+' + number, 'NATIONAL');
				}
			} catch (error) {
				formattedNumber = '';
				bugsnagClient.notify(error);
			}
			BarkConnect.callerNumber = formattedNumber.length > 0 ? formattedNumber : number;
		};

		BarkConnect.fillInCalleeDataForRow = function (data) {
			var avatar = data.calleeAvatar;
			var image;

			$('.js-bc-callee-name').text(data.calleeName);
			$('.js-bc-callee-letter').text((data.calleeName || '?')[0].toUpperCase());
			$('.js-caller-formatted-telephone').text(data.callerNumber);

			image = $('<img class="user-avatar rounded">');

			if (avatar) {
				image.attr('src', avatar);
				$('.avatar-image-container').html(image);
			}
		};

		BarkConnect.isFoundation = function () {
			return $(this.modalId).hasClass('reveal-modal');
		};

		BarkConnect.triggerBarkConnect = function (data) {
			var BC = BarkConnect;
			data.projectId = data.forTypeId;
			BC.state = {
				name: 'trigger-bark-connect',
				data: data,
			};

			BC.calleeUserType =
				data.calleeUserType === 'buyer' ? 'buyer_user' : data.calleeUserType;
			BC.calleeUserTypeId = data.calleeUserTypeId;
			BC.calleeName = data.calleeName;
			BC.forType = data.forType;
			BC.forTypeId = data.forTypeId;

			if (data.callerNumber && !BarkConnect.callerNumber) {
				BarkConnect.setCallerNumber(data.callerNumber);
			}

			BC.fillInCalleeDataForRow({
				calleeName: BC.calleeName,
				callerNumber: BarkConnect.callerNumber,
			});

			BC.openModal(BC.modalId);
		};

		BarkConnect.startCallMeNow = function () {
			if (window.RadialProgress) {
				let RadialProgress = window.RadialProgress;
				new RadialProgress(75, 8, '#47BF9C', '#FFF', '#000', 10).setProgress(100, 5);
			}
			var BC = BarkConnect;
			BC.showStep('.page-2');
			let timeout = 5000;
			if (typeof BC.timeOut === 'undefined') {
				BC.timeOut = setTimeout(function () {
					BC.console('Initiating auto call');
					BC.callMeNow();
				}, timeout);
			}
		};

		BarkConnect.changePhoneNumber = function () {
			$('.phone-number-error').addClass('d-none');
			if (BarkConnect.state) {
				if (BarkConnect.state.name === 'trigger-bark-connect') {
					BarkConnect.stopAutoCall();
				}
			}
			BarkConnect.showStep('.page-change-phone-number');
		};

		BarkConnect.cancelChangePhoneNumber = function () {
			BarkConnect.backToState();
		};

		BarkConnect.setPhoneNumber = function (newPhoneNumber) {
			let onSuccess = function (phoneNumber) {
				BarkConnect.backToState();
			};
			let onError = function (error) {
				let errorMsg = _t('seller_bark-connect:phone-validation-message');
				try {
					let errorMsgs = error.responseJSON.error.errors.phone_number;
					errorMsg = errorMsgs.join('\n');
				} catch (err) {
					// do nothing use default message
				}
				$('.phone-number-error').text(errorMsg);
				$('.phone-number-error').removeClass('d-none');
				console.log(error);
			};
			BarkConnect.updatePhoneNumber(newPhoneNumber, onSuccess, onError);
		};

		BarkConnect.backToState = function () {
			let state = BarkConnect.state;
			if (state) {
				if (state.name === 'trigger-bark-connect') {
					BarkConnect.triggerBarkConnect(state.data);
				} else if (state.name === 'schedule-call') {
					BarkConnect.triggerScheduleCall(state.data);
				} else if (state.name === 'reschedule-call') {
					BarkConnect.triggerReScheduleCall();
				}
			}
		};

		BarkConnect.getPhoneNumber = function () {
			let context = 'seller';
			if (!Bark.seller) {
				context = 'buyer';
			}
			Bark.api(
				'bark-connect/phone-number?context=' + context,
				{},
				function (data) {
					BarkConnect.setCallerNumber(data.data.phone_number);
				},
				function (error) {
					BarkConnect.setCallerNumber(null);
				},
				'GET',
			);
		};

		BarkConnect.updatePhoneNumber = function (
			phoneNumber,
			successCallback,
			errorCallback,
		) {
			let context = 'seller';
			if (!Bark.seller) {
				context = 'buyer';
			}
			let payload = {
				context: context,
			};
			Bark.api(
				'bark-connect/phone-number',
				{
					context: context,
					phone_number: phoneNumber.trim(),
				},
				function (data) {
					BarkConnect.setCallerNumber(data.data.phone_number);
					if (successCallback) {
						successCallback(Bark.BarkConnect.callerNumber);
					}
				},
				function (error) {
					if (errorCallback) {
						errorCallback(error);
					}
				},
				'PUT',
			);
		};

		/**
		 * This function is called several times. Ensure that .off is called before any .on event listeners are added
		 */
		BarkConnect.bind = function () {
			var BC = this;

			$('.js-bark-connect')
				.off('click.barkConnect')
				.on('click.barkConnect', function (e) {
					var t = $(this);
					var data = t.data() || {};

					e.preventDefault();

					BarkConnect.triggerBarkConnect(data);
				});

			$('.js-call-me-now')
				.off('click.callMeNow')
				.on('click.callMeNow', function (e) {
					e.preventDefault();
					// needed to reset animation
					BC.stopAutoCall();
					BC.startCallMeNow();
				});

			$('.js-cancel-call-me-now')
				.off('click.cancelCallMeNow')
				.on('click.cancelCallMeNow', function (e) {
					e.preventDefault();
					BC.stopAutoCall();
					BC.backToState();
				});

			$('.close-modal, .close')
				.off('click.closeModal')
				.on('click.closeModal', function (e) {
					e.preventDefault();
					BC.closeModal();
				});

			$('.js-submit-connect-feedback')
				.off('click.submitFeedback')
				.on('click.submitFeedback', function (e) {
					e.preventDefault();
					BC.sendFeedBack();
				});

			$('#barkConnectModal #otherText')
				.off('focus.otherText')
				.on('focus.otherText', function () {
					$('#barkConnectModal #otherRadio')[0].checked = true;
					$('#barkConnectModal #otherRadio').change();
				});

			$('.js-bark-connect-feedback-input')
				.off('change.highlight')
				.on('change.highlight', function () {
					$('.js-bark-connect-feedback-input').next('label').removeClass('bg-grey-50');
					$(this).next('label').addClass('bg-grey-50');
				});

			$('.js-change-number')
				.off('click.changePhoneNumber')
				.on('click.changePhoneNumber', function (e) {
					e.preventDefault();
					BC.changePhoneNumber();
				});

			$('.js-go-back')
				.off('click.cancelChangePhoneNumber')
				.on('click.cancelChangePhoneNumber', function (e) {
					e.preventDefault();
					BC.cancelChangePhoneNumber();
				});
			$('.js-set-phone-number')
				.off('click.setPhoneNumber')
				.on('click.setPhoneNumber', function (e) {
					e.preventDefault();
					BC.setPhoneNumber($('#new_phone_number').val());
				});

			$('.js-send-an-sms')
				.off('click.sendSMS')
				.on('click.sendSMS', function (e) {
					e.preventDefault();
					BC.logRetryOutcome('sms');
					BC.closeModal();
					BC.smsCallback();
				});

			$('.js-reschedule-call')
				.off('click.rescheduleCall')
				.on('click.rescheduleCall', function (e) {
					e.preventDefault();
					BC.triggerScheduleCall(BC.state.data);
				});

			$('.js-do-schedule-call')
				.off('click.schedule')
				.on('click.schedule', function () {
					var t = $(this);
					var tz = jstz.determine();
					var dateTimeString =
						$('.js-bc-day-selector:visible').val() +
						' ' +
						$('.js-bc-time-selector:visible').val();
					var data = {
						project_id: BarkConnect.scheduledCallProjectId,
						local_timestamp: Number(moment(dateTimeString)) / 1000,
						timezone: tz.name(),
					};

					if (BC.barkConnectCallFlowGroupInstanceHash) {
						data.bark_connect_call_flow_group_instance_hash =
							BC.barkConnectCallFlowGroupInstanceHash;
					}
					BarkConnect.isRetry = false;

					if (t.attr('disabled')) {
						return;
					}

					BC.showLoadingSpinnerForButton('.js-do-schedule-call');
					t.attr({ disabled: 'disabled' });

					Bark.api &&
						window.Bark.api(
							'bark-connect/schedule-for-project/',
							data,
							function (e) {
								var scheduledDate;
								var tzShortName;
								var successMessage;
								var suffix = '';
								var format = 'dddd, Do MMMM';

								BC.hideLoadingSpinnerForButton(
									'.js-do-schedule-call',
									_t('seller_bark-connect:scheduling-call-button'),
								);
								t.removeAttr('disabled');

								if (!e.status) {
									$('.js-schedule-call-error').text(
										_t('seller_bark-connect:scheduling-error-message'),
									);

									if (e.error && e.error.message) {
										$('.js-schedule-call-error').text(e.error.message);
									}

									BarkConnect.showStep('.page-schedule-call-failure');
									return;
								}

								scheduledDate = moment(e.data.js_timestamp);
								tzShortName = moment()
									.tz(e.data.original_timezone)
									.format('z')
									.toUpperCase();

								if (!Bark.in_array(tzShortName, ommittedTimezones)) {
									scheduledDate.tz(e.data.original_timezone);
									suffix = ' (' + tzShortName + ')';
								}

								if (scheduledDate.isSame(new Date(), 'day')) {
									format = '[Today]';
								}

								if (moment().add(1, 'day').isSame(scheduledDate, 'day')) {
									format = '[Tomorrow]';
								}

								successMessage = scheduledDate.format(format + ' [at] H:mm') + suffix;

								$('.js-scheduled-call-date').text(successMessage);
								BarkConnect.showStep('.page-schedule-call-success');

								if (BC.activityLog) {
									BC.activityLog.redraw();
								}
							},
							function () {
								$('.js-schedule-call-error').text(
									_t('seller_bark-connect:scheduling-error-message'),
								);
								BarkConnect.showStep('.page-schedule-call-failure');
								BC.hideLoadingSpinnerForButton(
									'.js-do-schedule-call',
									_t('seller_bark-connect:scheduling-call-button'),
								);
								t.removeAttr('disabled');
							},
							'POST',
						);
				});

			$('.js-schedule-try-again')
				.off('click.retry')
				.on('click.retry', function () {
					Bark.BarkConnect.showStep('.page-schedule-call');
				});
		};

		BarkConnect.stopAutoCall = function () {
			clearTimeout(this.timeOut);
			this.timeOut = undefined;
		};

		BarkConnect.endpoints = {
			seller_profile: 'bark-connect/buyer-initiate/buyer_call_seller_v1/',
			buyer_user: 'bark-connect/seller-initiate/seller_call_buyer_v1/',
		};

		BarkConnect.source_page = null;

		BarkConnect.getSourcePage = function () {
			if (BarkConnect.source_page) {
				return BarkConnect.source_page;
			}

			if (Bark.GET('bc_scheduled')) {
				return 'scheduled';
			}

			if (location.pathname.match(/sellers\/my-barks/)) {
				return 'responses';
			}

			if (location.pathname.match(/sellers\/dashboard/)) {
				return 'leads';
			}

			return null;
		};

		BarkConnect.getSourceDeviceType = function () {
			var isProbablyMobile = navigator.userAgent.match(
				/Android|webOS|iPhone|iPad|iPod|BlackBerry/i,
			);

			if (isProbablyMobile) {
				return 'probably_mobile';
			}

			return 'probably_desktop';
		};

		BarkConnect.callMeNow = function () {
			var BC = this;

			BarkConnect.console('Calling the initiator');

			this.showStep('.page-calling-caller');
			BC.stopAutoCall();

			Bark.api &&
				window.Bark.api(
					BarkConnect.endpoints[BC.calleeUserType],
					{
						users: [
							{
								user_type: BC.calleeUserType,
								user_type_id: BC.calleeUserTypeId,
							},
						],
						source_page: BarkConnect.getSourcePage(),
						source_device: BarkConnect.getSourceDeviceType(),
						map: {
							type: BC.forType,
							id: BC.forTypeId,
						},
					},
					function (response) {
						BC.console('Subscribing to chat room with hash: ' + response.callHash);
						try {
							BC.connectToChatRoom(response.callHash);
							BC.barkConnectCallFlowGroupInstanceHash = response.callHash;
						} catch (e) {
							console.log(e);
						}
					},
					function () {
						BC.closeModal();
					},
					'POST',
				);
		};

		BarkConnect.callerDidNotPickUp = function () {
			BarkConnect.console('The caller did not pick up their phone');

			this.showStep('.page-caller-did-not-pick-up');
		};

		BarkConnect.connectCallerToCallee = function () {
			BarkConnect.console(
				'The caller has picked up their phone and it is now time to connect the callee',
			);

			this.showStep('.page-connecting-callee');
		};

		BarkConnect.calleePickedUp = function () {
			BarkConnect.console('The callee has picked up');

			$('.status-title').html(
				_t('seller_bark-connect:connected-to-callee', {
					buyer_public_name: BarkConnect.calleeName,
					line_break: '<br>',
					interpolation: { escapeValue: false },
				}),
			);

			$('.phone-status-circle').remove();
			$('.page-call-status .avatar-image-container').append(
				$('<div class="phone-status-circle bg-success">'),
			);

			if (window.CountUpModule) {
				$('.phone-call-timer').removeClass('d-none');
				window.CountUpModule.startTimer();
			}

			this.showCallStatusPage();
		};

		BarkConnect.showCallStatusPage = function () {
			this.showStep('.page-call-status');
		};

		BarkConnect.calleeConnectionFailed = function () {
			BarkConnect.console("Couldn't get hold of the callee");

			$('.status-title').text(
				_t('seller_bark-connect:callee-not-available', {
					buyer_public_name: BarkConnect.calleeName,
				}),
			);
			$('.phone-status-circle').remove();
			$('.page-call-status .avatar-image-container').append(
				$('<div class="phone-status-circle bg-error">'),
			);

			$('.page-call-status').append(
				'<button class="btn btn-primary large-btn my-3">' +
					_t('seller_bark-connect:request-callback-button') +
					'</button>',
			);

			this.showCallStatusPage();
		};

		BarkConnect.stopCallTimer = function () {
			if (window.CountUpModule) {
				$('.phone-call-timer').addClass('d-none');
				window.CountUpModule.stopTimer();
			}
		};

		BarkConnect.hangUp = function (callProgress) {
			BarkConnect.console('Hanging up the call');
			if (
				!BarkConnect.lastInstanceHash ||
				BarkConnect.lastInstanceHash !== BarkConnect.barkConnectCallFlowGroupInstanceHash
			) {
				BarkConnect.lastInstanceHash = BarkConnect.barkConnectCallFlowGroupInstanceHash;
			} else {
				return;
			}
			this.stopCallTimer();

			var showFeedbackSurvey =
				(this.lastStatus === 'callee_answered' && callProgress === 'caller_hung_up') ||
				(this.lastStatus === 'callee_hung_up' && callProgress === 'caller_hung_up') ||
				callProgress === 'callee_hung_up';

			let retryLater = false;
			if (window.CountUpModule.getSeconds() <= 10) {
				retryLater = true;
			}

			BarkConnect.console('Show survey: ' + (showFeedbackSurvey ? ' Yes' : ' No'));

			if (retryLater) {
				BarkConnect.logRetryOutcome('init');
				if (!this.modalIsOpen()) {
					this.openModal();
				}

				$('.retry-later .avatar-image-container .phone-status-circle').remove();
				$('.retry-later .avatar-image-container').append(
					$('<div class="phone-status-circle bg-red">'),
				);

				if (BarkConnect.smsCallback) {
					$('.retry-later-for-sms').removeClass('d-none');
					$('.retry-later-for-no-sms').addClass('d-none');
				} else {
					$('.retry-later-for-sms').addClass('d-none');
					$('.retry-later-for-no-sms').removeClass('d-none');
				}
				this.showStep('.retry-later');
			} else if (showFeedbackSurvey) {
				console.log('Is modal open?: ' + this.modalIsOpen());
				if (!this.modalIsOpen()) {
					this.openModal();
				}
				this.showStep('.page-feedback');
			} else {
				this.closeModal();
			}
		};

		BarkConnect.logRetryOutcome = function (outcome) {
			if (outcome !== 'init') {
				BarkConnect.isRetry = false;
			}
			Bark.api(
				'bark-connect/retry-outcome',
				{
					bark_connect_call_flow_group_instance_hash:
						this.barkConnectCallFlowGroupInstanceHash,
					outcome: outcome,
				},
				function () {
					// done
				},
				function (error) {
					console.error(error);
				},
				'PUT',
			);
		};

		BarkConnect.showStep = function (selector) {
			if (
				window.Bark.in_array(selector, [
					'.page-schedule-call',
					'.page-feedback',
					'.page-scheduled-change-phone-number',
					'.page-change-phone-number',
				])
			) {
				$('.js-bark-connect-modal-body')
					.removeClass('pt-5')
					.removeClass('pt-4')
					.addClass('pt-0');
			} else if (
				window.Bark.in_array(selector, [
					'.page-1',
					'.page-2',
					'.retry-later',
					'.page-calling-caller',
					'.page-connecting-callee',
					'page-call-status',
				])
			) {
				$('.js-bark-connect-modal-body')
					.removeClass('pt-5')
					.addClass('pt-4')
					.removeClass('pt-0');
			} else {
				$('.js-bark-connect-modal-body')
					.addClass('pt-5')
					.removeClass('pt-4')
					.removeClass('pt-0');
			}

			$('.modal-page').removeClass('d-flex').addClass('d-none');
			$(selector).removeClass('d-none').addClass('d-flex');
		};

		/**
		 * Logs an event
		 * @param {string} eventName
		 * @param {string} eventIdentifier
		 * @param {string} eventCategory
		 */
		BarkConnect.logEvent = function (eventName, eventIdentifier, eventCategory) {
			try {
				eventCategory = eventCategory || 'bark_connect_callee_contact_modal';
				$.post('/api/elo/', {
					c: eventCategory,
					n: eventName,
					i: eventIdentifier,
				});
			} catch (e) {
				bugsnagClient.notify(e);
			}
		};

		/**
		 *
		 * @param modalId
		 */
		BarkConnect.openModal = function (modalId) {
			if (!modalId) {
				modalId = this.modalId;
			}

			this.showStep('.page-1');

			// Buyer dashboard uses foundation
			if ($(modalId).hasClass('reveal-modal')) {
				$(document).scrollTop(0);
				$(modalId).foundation('reveal', 'open');
			} else {
				$(modalId).modal('show');
			}

			this.logEvent('show_modal', this.calleeUserType + ':' + this.calleeUserTypeId);
		};

		/**
		 *
		 * @param modalId
		 */
		BarkConnect.closeModal = function (modalId) {
			if (!modalId) modalId = this.modalId;

			this.stopAutoCall();
			this.stopCallTimer();

			if (BarkConnect.activityLog) {
				BarkConnect.activityLog.redraw();
			}

			// Buyer dashboard uses foundation
			if ($(modalId).hasClass('reveal-modal')) {
				$(modalId).foundation('reveal', 'close');
			} else {
				$(modalId).modal('hide');
			}

			this.resetFeedbackForm();

			this.logEvent('hide_modal', this.calleeUserType + ':' + this.calleeUserTypeId);

			if (BarkConnect.isRetry) {
				BarkConnect.logRetryOutcome('skipped');
			}
		};

		BarkConnect.modalIsOpen = function (modalId) {
			if (!modalId) modalId = this.modalId;

			// Buyer dashboard uses foundation
			if ($(modalId).hasClass('reveal-modal')) {
				return $(modalId).hasClass('open');
			} else {
				return $(modalId).hasClass('show');
			}
		};

		BarkConnect.resetFeedbackForm = function () {
			BarkConnect.console('clearing the form');

			$('input[name=connectFeedbackOption]').attr('checked', false);
			$('#feedback-error').text('').addClass('d-none');
			$('#temp-to-clear-change')[0].checked = true;
			$('.js-bark-connect-feedback-input').change();
			$('#temp-to-clear-change')[0].checked = false;
		};

		BarkConnect.sendFeedBack = function () {
			BarkConnect.console('sending feedback to our server');
			var BC = this;
			var otherText;

			if ($('.js-submit-connect-feedback').attr('disabled')) {
				return;
			}

			$('.js-submit-connect-feedback').attr({ disabled: 'disabled' });

			BC.showLoadingSpinnerForButton('.js-submit-connect-feedback');

			var optionChosen = $('input[name=connectFeedbackOption]:checked').val();

			if (!optionChosen) {
				$('#feedback-error')
					.text(_t('seller_bark-connect:please-select-option'))
					.removeClass('d-none');
				BC.hideLoadingSpinnerForButton('.js-submit-connect-feedback');
				$('.js-submit-connect-feedback').removeAttr('disabled');
				return;
			}

			if (optionChosen === 'other') {
				otherText = $('#otherText').val();

				if (otherText.length <= 30) {
					$('#feedback-error')
						.text(_t('seller_bark-connect:feedback-length-error-message'))
						.removeClass('d-none');
					BC.hideLoadingSpinnerForButton('.js-submit-connect-feedback');
					$('.js-submit-connect-feedback').removeAttr('disabled');
					return;
				}
			}

			if (window.Bark) {
				window.Bark.api(
					'bark-connect/feedback',
					{
						bark_connect_call_flow_group_instance_hash:
							this.barkConnectCallFlowGroupInstanceHash,
						type: optionChosen,
						other_text: otherText,
					},
					function () {
						if (optionChosen === 'no-answer') {
							let data = {
								projectId: BC.forTypeId,
								callee_user_type: BC.calleeUserType,
								callee_user_type_id: BC.calleeUserTypeId,
								callee_name: BC.calleeName,
								is_feedback_flow: true,
							};
							BC.triggerScheduleCall(data);
						} else {
							BC.closeModal();
						}
						$('#feedback-error').text('').addClass('d-none');
						BC.hideLoadingSpinnerForButton('.js-submit-connect-feedback');
						$('.js-submit-connect-feedback').removeAttr('disabled');
					},
					function () {
						$('#feedback-error')
							.text(_t('seller_bark-connect:feedback-unsaved-error-message'))
							.removeClass('d-none');
						BC.hideLoadingSpinnerForButton('.js-submit-connect-feedback');
						$('.js-submit-connect-feedback').removeAttr('disabled');
					},
					'POST',
				);
			}
		};

		BarkConnect.showLoadingSpinnerForButton = function (button) {
			$(button).html(
				'<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>' +
					'<span class="sr-only">' +
					_t('common:loading-message') +
					'</span>',
			);

			$(button).attr('disabled', 'disabled');
		};

		BarkConnect.hideLoadingSpinnerForButton = function (button, buttonText) {
			$(button).html(buttonText || 'Submit');
			$(button).attr('disabled', false);
		};

		BarkConnect.connectToChatRoom = function (callHash) {
      console.log('Websockets have been removed, please create a new implementation');

      return true;
		};

		BarkConnect.console = function () {
			if (this.debug) {
				console.log(...arguments);
			}
		};

		BarkConnect.triggerScheduleCall = function (data) {
			BarkConnect.state = {
				name: 'schedule-call',
				data: data,
			};

			let {
				projectId,
				calleeUserType: callee_user_type,
				calleeUserTypeId: callee_user_type_id,
				calleeName: callee_name,
				callerNumber,
				isFeedbackFlow: is_feedback_flow,
			} = data;

			var user_type = callee_user_type == 'buyer_user' ? 'buyer' : callee_user_type;
			var endpoint =
				'bark-connect/find-scheduled-times-for-' + user_type + '/' + callee_user_type_id;
			var title = is_feedback_flow
				? _t('seller_bark-connect:would-you-schedule-call-title')
				: _t('seller_bark-connect:schedule-call-title');
			var subtitle = is_feedback_flow
				? _t('seller_bark-connect:we-will-call-subtitle')
				: _t('seller_bark-connect:when-should-we-call-subtitle');

			$('.js-scheduled-call-title').text(title);
			$('.js-scheduled-call-subtitle').text(subtitle);
			$('.js-bc-callee-name-scheduled').text(callee_name);
			if (callerNumber && !BarkConnect.callerNumber) {
				BarkConnect.setCallerNumber(callerNumber);
			}
			$('.js-caller-formatted-telephone').text(BarkConnect.callerNumber);

			BarkConnect.init(); // Ensure that we're initialised

			BarkConnect.openModal();
			BarkConnect.showStep('.page-spinner');
			BarkConnect.scheduledCallProjectId = projectId;
			BarkConnect.scheduledCallCalleeUserType = callee_user_type;
			BarkConnect.scheduledCallCalleeUserTypeId = callee_user_type_id;

			this.logEvent('scheduled_call_modal', callee_user_type + ':' + callee_user_type_id);

			Bark.api &&
				window.Bark.api(
					endpoint,
					null,
					function (e) {
						if (!e.status) {
							BarkConnect.closeModal();
							return;
						}

						unavailableTimes = e.data.times;

						buildScheduleCallElement();
						BarkConnect.showStep('.page-schedule-call');
					},
					function () {
						BarkConnect.closeModal();
					},
					'GET',
				);
		};

		function buildScheduledCallTimeSelector(startAt, date, minTime) {
			var i = 0;
			var j = 0;
			var intervals = ['00', '15', '30', '45'];
			var hr;
			var opts;
			var cur;
			var fullTime;

			$('.js-bc-time-selector').empty();

			for (i = startAt; i < 24; i++) {
				for (j = 0; j < intervals.length; j++) {
					hr = (i < 10 ? '0' : '') + i;
					fullTime = hr + ':' + intervals[j] + ':00';

					if (minTime && fullTime < minTime) {
						continue;
					}

					opts = {
						text: hr + ':' + intervals[j],
						value: fullTime,
					};

					if (unavailableTimes[date] && Bark.in_array(fullTime, unavailableTimes[date])) {
						opts['disabled'] = 'disabled';
					}

					if (fullTime === BarkConnect.scheduledCallDefaultTime) {
						opts['selected'] = 'selected';
					}

					$('.js-bc-time-selector').append($('<option>', opts));
				}
			}
		}

		function buildScheduleCallElement() {
			var dateLabels = [];
			var i;
			var label;
			var mmnt;
			var j = 0;
			var tzShortName;

			$('.js-schedule-timezone').addClass('d-none').removeClass('d-block');

			try {
				tzShortName = moment().tz(jstz.determine().name()).format('z').toUpperCase();

				if (!Bark.in_array(tzShortName, ommittedTimezones)) {
					$('.js-schedule-timezone')
						.removeClass('d-none')
						.addClass('d-block')
						.text(
							_t('seller_bark-connect:all-times-in-timezone', {
								timezone_format: tzShortName,
							}),
						);
				}
			} catch (ex) {
				window.bugsnagClient && window.bugsnagClient.notify(ex);
			}

			$('.js-bc-day-selector').empty();

			for (i = 0; i < 7; i++) {
				mmnt = moment().add(i, 'days');

				if (i == 0) {
					label = _t('seller_bark-connect:today-label');
				} else if (i == 1) {
					label = _t('seller_bark-connect:tomorrow-label');
				} else {
					label = mmnt.format('dddd');
				}

				$('.js-bc-day-selector').append(
					$('<option>', { text: label, value: mmnt.format('YYYY-MM-DD') }),
				);
			}

			$('.js-bc-day-selector')
				.off('change.updateTimes')
				.on('change.updateTimes', function () {
					var today = moment().format('YYYY-MM-DD');
					var startAt = 0;
					var minTime;

					if (today === this.value) {
						startAt = moment().format('H');
						minTime = moment().format('HH:mm:00');
					}

					buildScheduledCallTimeSelector(startAt, this.value, minTime);
				});

			$('.js-bc-day-selector').change();
		}

		BarkConnect.getPhoneNumber();

		_exposeToWindow(BarkConnect);
	};

	if (window.Bark.loadBConnect) {
		load();
	}
}
